import React from 'react';
import { HeroIconName, Image, SvgIcon, Tooltip } from '@gik/ui';
import { SupportGivenType } from '@gik/core/models/gik/ISupporter';
import { IHistoryEntry, SupportHistoryType } from '@gik/core/models/gik/IHistoryEntry';
import { ProductCheckoutType } from '@gik/core/models/gik/Product';

export function renderSupportIcon(entry: IHistoryEntry) {
  const tooltip = getSupportIconTooltip(entry.type, entry.isPendingFulfillment, entry.productCheckoutType);
  switch (entry.type) {
    case 'purchase': {
      const iconName: HeroIconName = entry.isPendingFulfillment
        ? 'Clock'
        : entry.productCheckoutType === 'giftbox'
        ? 'Gift'
        : entry.productCheckoutType === 'gik-premium'
        ? 'Star'
        : 'CreditCard';

      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name={iconName} />
          </div>
        </Tooltip>
      );
    }
    case 'follow':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Heart" />
          </div>
        </Tooltip>
      );
    case 'unfollow':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Heart" strikeOut />
          </div>
        </Tooltip>
      );
    case 'claim':
      return (
        <Tooltip text={tooltip}>
          <div>{entry.calendarEntry && <Image inline src={entry.calendarEntry.calendarEventTypeIcon} />}</div>
        </Tooltip>
      );
    case 'unclaim':
      return (
        <Tooltip text={tooltip}>
          <div className="gik-image-icon-strikeout">
            {entry.calendarEntry && <Image inline src={entry.calendarEntry.calendarEventTypeIcon} />}
          </div>
        </Tooltip>
      );
    case 'donation':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="CurrencyDollar" />
          </div>
        </Tooltip>
      );
    default:
      throw new Error(`unknown support icon "${entry.type}"`);
  }
}

export function getSupportIconTooltip(
  type: SupportHistoryType,
  isPendingFulfillment?: boolean,
  checkoutType?: ProductCheckoutType
) {
  switch (type) {
    case 'purchase':
      return (
        (checkoutType === 'gik-premium'
          ? 'Premium Page Upgrade'
          : checkoutType === 'giftbox'
          ? 'Gift Box'
          : checkoutType === 'tango-card'
          ? 'Gift Card'
          : 'Purchase') + (isPendingFulfillment ? ' (Pending Fulfillment)' : '')
      );
    case 'follow':
      return 'Follow';
    case 'unfollow':
      return 'Unfollow';
    case 'claim':
      return 'Claim';
    case 'unclaim':
      return 'Unclaim';
    case 'donation':
      return 'Donation';
    default:
      return type;
  }
}

export function renderSupportGivenIcon(type: SupportGivenType) {
  const tooltip = getSupportGivenIconTooltip(type);
  switch (type) {
    case 'follow':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Heart" />
          </div>
        </Tooltip>
      );
    case 'pending':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Clock" />
          </div>
        </Tooltip>
      );
    case 'premium':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Star" />
          </div>
        </Tooltip>
      );
    case 'calendar':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Calendar" />
          </div>
        </Tooltip>
      );
    case 'giftCard':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="CreditCard" />
          </div>
        </Tooltip>
      );
    case 'giftBox':
      return (
        <Tooltip text={tooltip}>
          <div>
            <SvgIcon name="Gift" />
          </div>
        </Tooltip>
      );
    default:
      throw new Error(`unknown support icon "${type}"`);
  }
}

export function getSupportGivenIconTooltip(type: SupportGivenType) {
  switch (type) {
    case 'follow':
      return 'Follow';
    case 'pending':
      return 'Gift Card Pending';
    case 'premium':
      return 'Premium Page Upgrade';
    case 'donation':
      return 'Donation';
    case 'calendar':
      return 'From Calendar';
    case 'giftCard':
      return 'Gift Card';
    case 'giftBox':
      return 'Gift Box';
    default:
      return type;
  }
}
